<template>
<div class="chapter">
<div class="inner_page">
<div id="a07_poem">
<a id="page_9">
<p class="poem">Long ago we were boys in the ranks comrades,<br/> Our hearts light and happy as the day,<br/> Cheeks were ruddy, eyes bright, locks dark, comrades,<br/> As we marched from our homes far away.</p>
<p class="poema">But now we are aged and gray comrades,<br/> The trials of life are nearly done,<br/> But to us life’s as dear as it was comrades,<br/> When you and I were young.</p>
<p class="author"><i>—Long Ago</i>, <span class="small">VERSE ONE AND CHORUS <br/>BY</span> J. M. C<span class="small">ARMICHAEL</span>, 1902 <br/><i>(recorded by Bobby Horton Music)</i></p>
</a></div><a id="page_9">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_poem.vue?9e22ee64